import { render } from "./logs-statistics-page.vue?vue&type=template&id=ec067b0e"
import script from "./logs-statistics-page.vue?vue&type=script&lang=ts"
export * from "./logs-statistics-page.vue?vue&type=script&lang=ts"

import "./logs-statistics-page.vue?vue&type=style&index=0&id=ec067b0e&lang=less"
script.render = render

export default script